import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import './TimeIsValuable.css';

const TimeIsValuable = ({ title, text, cta }) => {
  if (!title || !text) {
    return null;
  }

  return (
    <section className="time-is-valuable">
      <div className="time-is-valuable__inner">
        <Reveal className="time-is-valuable__content">
          <h2 className="time-is-valuable__title">{title}</h2>
          <p className="time-is-valuable__text">{text}</p>
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="time-is-valuable__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default TimeIsValuable;
